import { ScheduleVacation } from '@/plugins/api'
import { rangeRight } from 'lodash-es'

export default {
  namespaced: true,
  state: {
    searchParams: {},
    items: [],
    pageText: '',
    totalItems: 0,
    itemsPerPage: 5,
  },
  actions: {
    async search({ commit, state, dispatch }, query) {
      const searchParams = {
        _limit: state.itemsPerPage,
        ...query,
      }
      commit('changeState', { searchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        let searchParams = {
          ...state.searchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'date:DESC',
        }
        const [totalItems, items] = await Promise.all([
          ScheduleVacation.qsCount(searchParams),
          ScheduleVacation.qsFetch(searchParams),
        ])
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            items,
            totalItems,
            itemsPerPage,
            searchParams,
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
    },
    create(_, params) {
      return ScheduleVacation.create(params)
    },
    remove(_, id) {
      return ScheduleVacation.remove(id)
    },
    findOneIndependent(_, id) {
      return ScheduleVacation.fetchOne(id)
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
  },
  getters: {},
}
